import { Component, Input, OnInit } from '@angular/core';
import { AppService } from 'common-cloudstudio';

@Component({
  selector: 'app-static-image',
  templateUrl: './static-image.component.html',
  styleUrls: ['./static-image.component.scss']
})
export class StaticImageComponent implements OnInit{ 
  @Input() widgetDescriptor: any;
  @Input() widgetData: any;

  constructor(
    public _appService: AppService
  ) {}

  ngOnInit(): void {
  }
}
